import { ProgressBar } from 'react-bootstrap';
import styled from 'styled-components';

import { min } from '../utils/breakpoints';

const OuterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const InnerEndWrapper = styled.div`
  flex-shrink: 0;
  font-size: 14px;

  ${min.sm} {
    font-size: 16px;
  }
`;

const InnerMiddleWrapper = styled.div`
  flex: 1;
  margin: 0 10px;
  ${min.sm} {
    padding-top: 2px;
  }
`;

const StyledProgressBar = styled(ProgressBar)`
  border-radius: 6px;
  height: 11px;

  .progress-bar {
    border-radius: 6px;
    background: ${(props) => props.theme.colors.progressBar};
  }
`;

const OnboardingProgress = ({ percentage }) => (
  <div className="mb-4">
    <OuterWrapper>
      <InnerEndWrapper>Progress: </InnerEndWrapper>
      <InnerMiddleWrapper>
        <StyledProgressBar now={percentage} />
      </InnerMiddleWrapper>
      <InnerEndWrapper>{`${percentage}%`}</InnerEndWrapper>
    </OuterWrapper>
  </div>
);

export default OnboardingProgress;
